import React from 'react';

const ContactHero = () => {
  return (
    <section
      className="relative pt-28 pb-20 md:pt-28 md:pb-20 min-h-[480px] flex items-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`, // Local image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg">
          Connect with <span className="block md:inline md:ml-2 text-white">Eye&U Kenya</span>
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto mb-8 leading-relaxed drop-shadow-md">
          Multiple ways to reach our expert eye care team. Whether you need immediate assistance,
          want to schedule a consultation, or have questions about our services — we’re here to help through your preferred channel.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
